import React, { useContext, useEffect, useMemo, useRef } from "react";
import { CSVLink } from "react-csv";

import ActiveLearningLessonRetrospect from "../../../templates/teacher/ActiveLearningLessonRetrospect";
import {
  Context,
  fetchActiveLearningAnswersDownloadCsv,
  fetchActiveLearningAnswersProgress,
  fetchActiveLearningMaterialLessonsData,
} from "../../../teacherStore";
import { parseQueryParams } from "../../../libs/Util";
import useWaitApiCall from "../../../hooks/useWaitApiCall";
import useDidMountEffect from "../../../hooks/useDidMountEffect";

export default () => {
  const { state, dispatch } = useContext(Context);
  const [calling, peep] = useWaitApiCall(state);
  const [csvDownloadCalling, csvDownloadCPeep] = useWaitApiCall(state);
  const params = parseQueryParams();
  const classListInParams = params["classList"];
  // レンダリングのたびにclassListが異なるメモリに作成され
  // 再度useEffect内の処理が実行してしまうためメモ化
  const classList = useMemo<number[]>(
    () =>
      classListInParams
        ? classListInParams.split(",").map((classID: string) => Number(classID))
        : [],
    [classListInParams],
  );

  useEffect(() => {
    dispatch(peep(fetchActiveLearningMaterialLessonsData()));
    dispatch(peep(fetchActiveLearningAnswersProgress(classList)));
  }, [dispatch, peep, classList]);

  const csvLinkRef = useRef<
    CSVLink & HTMLAnchorElement & { link?: HTMLAnchorElement }
  >(null);

  const handleClickDownloadAnswersCsv = (
    class_ids: string,
    material_code: string,
  ) => {
    !csvDownloadCalling &&
      dispatch(
        csvDownloadCPeep(
          fetchActiveLearningAnswersDownloadCsv(class_ids, material_code),
        ),
      );
  };

  useDidMountEffect(() => {
    const timeout = setTimeout(() => {
      state.active_learning_answers_csv?.length &&
        csvLinkRef.current?.link &&
        csvLinkRef.current.link.click();
    });
    return () => clearTimeout(timeout);
  }, [csvLinkRef, state.active_learning_answers_csv]);

  return (
    <>
      <ActiveLearningLessonRetrospect
        activeLearningMaterialLessons={
          state.active_learning_material_lessons_data
        }
        activeLearningAnswersProgress={state.active_learning_answers_progress}
        availableItemCodes={state.available_item_codes}
        calling={calling}
        csvDownloadCalling={csvDownloadCalling}
        onClickDownloadAnswersCsv={handleClickDownloadAnswersCsv}
      />
      {state.active_learning_answers_csv && (
        <CSVLink
          ref={csvLinkRef}
          filename="実践編全Lesson回答一覧.csv"
          data={state.active_learning_answers_csv}
          uFEFF
          hidden
        />
      )}
    </>
  );
};
